import { Route, Routes } from "react-router-dom";
import FIleEditor from "./FIleEditor";
import FilePreviewPage from "./FilePreviewPage";
import NewProject from "./NewProject";
import ReceiveDocument from "./ReceiveDocument";
import SenderDocs from "./SenderDocs";
import SignatureDocuments from "./SignatureDocuments";
import SignedDocument from "./SignedDocument";
import DashboardLayout from "./layout/DashboardLayout";
import AuditTrail from "./pages/AuditTrail";
import BookMeeting from "./pages/Calendly/BookMeeting";
import CollabObject from "./pages/Collabs/CollabObject";
import CollabOverview from "./pages/Collabs/CollabOverView";
import CollabTabs from "./pages/Collabs/CollabTabs";
import RecivedCollabs from "./pages/Collabs/RecivedCollabs";
import Chat from "./pages/Collabs/chatcomponent/Chat";
import MyCompanies from "./pages/Comapnies/MyCompanies";
import Invitations from "./pages/Invitation/Invitations";
import NewConsent from "./pages/NewConsent";
import Profile from "./pages/Profile";
import PrivateChat from "./pages/chatComponent/PrivateChat";
import ReviewersChat from "./pages/chatComponent/ReviewersChat";
import SignersChat from "./pages/chatComponent/SignersChat";
import ContactTabs from "./pages/contacts/ContactTabs";
import CompanyCreditReport from "./pages/credits/CompanyCreditReport";
import CreditRequest from "./pages/credits/CreditRequest";
import CompanyCreditTransactionHistory from "./pages/credits/transactionReport/company/CompanyCreditTransactionHistory";
import CreditsUsageReport from "./pages/credits/transactionReport/user/CreditsUsageReport";
import Dashboard from "./pages/dashboard_stats/Dashboard";
import ConsenObject from "./pages/myconsents/ConsenObject";
import Consents from "./pages/myconsents/Consents";
import MyDocs from "./pages/mydocs/MyDocs";
import RecipientDocumentEditor from "./pages/recipent_document/RecipientDocumentEditor";
import FileReviewer from "./pages/reviewedDocuments/FileReviewer";
import ReviewerConsesnts from "./pages/reviewedDocuments/ReviewerConsesnts";
import EditTemplate from "./pages/templates/EditTemplate";
import Templates from "./pages/templates/Templates";

const DashboardRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="/new-project" element={<NewProject />} />
        <Route path="/file-editor" element={<FIleEditor />} />
        <Route path="/preview" element={<FilePreviewPage />} />
        <Route path="/receiveDcoment" element={<ReceiveDocument />} />
        <Route path="/signedDocument/:id" element={<SignedDocument />} />
        <Route path="/sender-docs" element={<SenderDocs />} />
        <Route path="/pdf-viewer" element={<SignatureDocuments />} />
        <Route path="/my-consents" element={<Consents />} />
        <Route
          path="/my-consents/new-consent/step/:step"
          element={<NewConsent />}
        />
      s
        <Route path="/my-consents/audit-trail" element={<AuditTrail />} />
        <Route path="/my-docs" element={<MyDocs />} />
        {/* <Route path="/my-docs/view" element={<RecipentViewDoc />} /> */}
        <Route path="/my-docs/view" element={<RecipientDocumentEditor />} />
        <Route path="/contacts" element={<ContactTabs />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="templates/edit-template" element={<EditTemplate />} />
        <Route path="/contacts/chat" element={<Chat />} />
        <Route path="/creditPassBook" element={<CreditRequest />} />
          {/* <Route
          path="/creditPassBook/transactionReport/user"
          element={<TransactionReport />}
        /> */}
           <Route
          path="/creditPassBook/transactionReport"
          element={<CreditsUsageReport />}
        />
        {/* <Route
          path="/creditPassBook/my-companies/:companyName/transactionLedger"
          element={<TransactionLedger />}
        /> */}
        <Route
          path="/creditPassBook/my-companies/:companyName/transactionLedger"
          element={<CompanyCreditTransactionHistory />}
        />
        {/* <Route
          path="/creditPassBook/my-companies/:companyName/company-transaction-history"
          element={<CompanyCreditTransactionHistory />}
        /> */}
        <Route path="/creditPassBook/my-companies" element={<MyCompanies />} />
        <Route
          path="/creditPassBook/my-companies/:companyKey"
          element={<CompanyCreditReport />}
        />
        <Route path="/invitations" element={<Invitations />} />
        <Route path="/review-documents" element={<ReviewerConsesnts />} />
        <Route
          path="/review-documents/review-file"
          element={<FileReviewer />}
        />
        <Route path="/my-collabs" element={<CollabTabs />} />
        <Route path="/my-collabs/create-collab" element={<CollabOverview />} />
        <Route path="/my-collabs/collab-object" element={<CollabObject />} />
        <Route
          path="/my-collabs/recived-collabs"
          element={<RecivedCollabs />}
        />
        <Route path="/my-consents/consent-object" element={<ConsenObject />} />
        <Route path="/my-collabs/new-collab" element={<CollabOverview />} />
        <Route path="/chat-app-signers" element={<SignersChat />} />
        <Route path="/chat-app-reviewers" element={<ReviewersChat />} />
        <Route path="/private-chat" element={<PrivateChat />} />
        {/* <Route path="/my-collabs/collab-report" element={<CollabReport />} /> */}
       <Route path="/schedule-meeting" element={<BookMeeting />} />
  
      </Route>
    </Routes>
  );
};

export default DashboardRoute;
